import { NgModule } from '@angular/core';

import { RekeningvalidatieResource } from './rekeningvalidatie.resource';

@NgModule({
    providers: [RekeningvalidatieResource]
})
export class RekeningvalidatieModule {}
